import Backbone from 'backbone'
import template from './scorecards-edit.hbs'
import Header from 'scoreboard/scorecards/scorecards-display-header'
import tabs from '../scorecards-tabs.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import EditButtons from 'scoreboard/components/edit/edit-buttons'
import scorecardsPasteAllowed, { locked } from './scorecards-paste-allowed'
import calendars from 'scoreboard/components/calendars'
import config from 'scoreboard/components/config'
import constants from 'scoreboard/components/constants'
import enums from 'scoreboard/components/enums'
import formHelper from 'scoreboard/components/form-helper'
import WeightForm from './weight-form'
import ScorecardsAdvancedForm from './scorecards-advanced-form'
import EquationForm from './equation-form'
import appDisplay from 'scoreboard/components/app-display'
import formatValue from 'scoreboard/components/format-value'
import dropdown from 'scoreboard/components/dropdown'
import $ from 'jquery'
import FormView from 'scoreboard/components/form-view'
import conductor from 'scoreboard/components/conductor'
import ObjectSelector from 'scoreboard/components/object-selector'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator
	from 'scoreboard/components/validators/required-validator'
import numericEvaluator
	from 'scoreboard/components/evaluators/numeric-evaluator'
import numericValidator
	from 'scoreboard/components/validators/numeric-validator'
import TextArea from 'scoreboard/components/textarea'
import currency from 'scoreboard/components/currency'
import selects from 'scoreboard/components/selects'
import ScorecardsUpdatersPanel from './scorecards-updaters-panel'
import ScorecardsOwnersPanel from './scorecards-owners-panel'
import ScorecardNode from '../scorecard-node'
import seriesNames from '../series-names'
import autofocus from 'scoreboard/polyfills/autofocus'
import cannotEdit from 'scoreboard/components/cannot-edit.hbs'
import DateInput from 'scoreboard/components/date-input'
import OnOffToggle from 'scoreboard/components/on-off-toggle'
import permissions from 'scoreboard/components/permissions'
import Tooltip from 'scoreboard/components/tooltip'
import AssignmentAlerts from 'scoreboard/components/assignment-alerts'
import scorecardsEditSeries from './scorecards-edit-series.hbs'
import DatasetSeriesEditor from './dataset-series-editor'
import datasetSeriesDrilldown
	from 'scoreboard/datasets/overview/dataset-series-drilldown'
import guard from 'scoreboard/components/unsaved/guard'
import Wizard from 'scoreboard/reports/wizard/reports-wizard'
import WizardInfo from 'scoreboard/reports/wizard/reports-wizard-info'
import ScorecardAttributesReportModel
	from 'scoreboard/reports/wizard/scorecard-attributes/scorecard-attributes-model'
import globals from 'scoreboard/components/globals'
import user from 'scoreboard/components/user'
import treeIdsInFilters from 'scoreboard/datasets/tree-ids-in-filters'
import Dataset from 'scoreboard/datasets/model/dataset'
import setupErrors from 'scoreboard/components/setup-errors'
import EditableButton from 'scoreboard/components/editable-button'
import ImportOptions from 'scoreboard/components/import-options'
import SendToOptions from 'scoreboard/components/send-to-options'
import metricEquationParser from 'scoreboard/scorecards/metric-equation-parser'
import * as adminLink from 'scoreboard/components/admin-link'
import DataType from 'scoreboard/datasets/model/data-type'
import { triggerAddOrEdit } from 'scoreboard/components/domain-object-events'
import { isV6 } from 'scoreboard/components/version'

import { weightInDateRange } from './weight-date-ranges-form'

const { SNAPSHOT } = Dataset
const { CURRENCY, NUMBER, PERCENT, YES_NO } = DataType

const USE_EQUATION = 'use-equation'

// don't try to use scoreboard/components/enums because they are hashes without a defined
// order, but the order here is important
var numericAggregationTypes = [
	{ id: 'sum', label: 'scorecards.node.metric.aggregationType.sum', icon: 'sum' },
	{ id: 'average', label: 'scorecards.node.metric.aggregationType.average', icon: 'average' },
	{ id: 'geometric-mean', label: 'scorecards.node.metric.aggregationType.geometricMean', icon: 'geometric-mean'},
	{ id: 'last-value', label: 'scorecards.node.metric.aggregationType.lastValue', icon: 'last-value' }
]

var yesNoAggregationTypes = [
	{ id: 'percentage-yes', label: 'scorecards.node.metric.aggregationType.percentageYes', icon: 'percent' },
	{ id: 'number-of-yeses', label: 'scorecards.node.metric.aggregationType.numberOfYeses', icon: 'number' },
	{ id: 'last-value', label: 'scorecards.node.metric.aggregationType.lastValue', icon: 'last-value' }
]

var customTextAggregationTypes = [
	{ id: 'percentage-reaching-goal', label: 'scorecards.node.metric.aggregationType.percentageReachingGoal', icon: 'percent' },
	{ id: 'number-reaching-goal', label: 'scorecards.node.metric.aggregationType.numberReachingGoal', icon: 'number' },
	{ id: 'last-value', label: 'scorecards.node.metric.aggregationType.lastValue', icon: 'last-value' }
]

var unscoredCustomTextAggregationTypes = [
	{ id: 'last-value', label: 'scorecards.node.metric.aggregationType.lastValue', icon: 'last-value' }
]

var numericRollupAggregationTypes = [
	{ id: 'sum', label: 'scorecards.node.metric.aggregationType.sum', icon: 'sum' },
	{ id: 'average', label: 'scorecards.node.metric.aggregationType.average', icon: 'average' },
	{ id: 'geometric-mean', label: 'scorecards.node.metric.aggregationType.geometricMean', icon: 'geometric-mean'}
]

var yesNoRollupAggregationTypes = [
	{ id: 'percentage-yes', label: 'scorecards.node.metric.aggregationType.percentageYes', icon: 'percent' },
	{ id: 'number-of-yeses', label: 'scorecards.node.metric.aggregationType.numberOfYeses', icon: 'number' }
]

var numberOfYesesAggregationTypes = [
	{ id: 'sum', label: 'scorecards.node.metric.aggregationType.sum', icon: 'sum' },
	{ id: 'average', label: 'scorecards.node.metric.aggregationType.average', icon: 'average' }
]

var updateTypes = [
	{ id: 'manual', label: 'scorecards.node.metric.updateType.manual', icon: 'manual' },
	{ id: 'calculated', label: 'scorecards.node.metric.updateType.calculated', icon: 'calculated' },
	{ id: 'rollup', label: 'scorecards.node.metric.updateType.rollup', icon: 'sum' },
	{ id: 'dataset', label: 'scorecards.node.metric.updateType.dataset', icon: 'dataset' }
]

function isExistingDockingNipr(model) {
	return config.replicationOutputEnabled && !model.isNew() && model.get('type') === 'docking'
}

var ScorecardsEdit = Backbone.View.extend({

	// this.model is a ScorecardNode

	tagName: 'form',

	className: 'table-hack display-layout scorecards-edit form',

	events: {
		'click .cancel': 'cancel',
		'change .item-type': 'changeType',
		'change .scoring-type': 'changeScoringType',
		'change .update-type': 'changeUpdateType',
		'change .data-type': 'changeDataType',
		'change .aggregation-type': 'changeAggregationType',
		'change .currency-code': '_remark',
		'change .unit': '_remark',
		'change [name=useSourceOwners]': '_toggleOwnersForLinked',
		'change [name=useSourceName]': 'changeUseSourceName',
		'change [name=useTemplate]': 'toggleUseTemplate',
		'click .weight': 'weight',
		'click .advanced': 'advanced',
		'click .set-equation': 'equation',
		'input .default-value' : 'toggleThresholdOverride',
		'click .go-to-origin': 'goToOrigin',
		'click .dataset-series': 'editDatasetSeries',
		'click .dataset-series .text-link': 'viewDataset',
		'click .scorecard-attribute-report.text-link': 'generateScorecardAttributeReport',
		'click .template-link': 'navigateToTemplate',
		'click .report-wizard.text-link': 'showReportWizard',
		'click .mass-edit-info .hide-banner': 'hideMassEditBanner',
		'click .mass-edit-info .text-link' : 'onClickMassEditLink',
		'click .scorecard-calendar': 'showDisabledCalendarTooltip'
	},

	initialize: function() {
		this.originalModel = new ScorecardNode(_.cloneDeep(this.model.attributes))
		this.editButtons = new EditButtons({
			section: 'scorecards',
			model: this.model,
			pasteAllowed: scorecardsPasteAllowed
		})
		this.editButtons.on('cancel', this.trigger.bind(this, 'cancel'))

		this._markedFields = []
		this._unsetUnwantedDefaults()

		if (this.model.isNew()) {
			this.model.set('label', i18n.get('scorecards.newItem'))
		}

		this.formView = new FormView({
			toggleCancel: true,
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: () => {
				// #43166 the name is pre-populated, so allow saving
				if (this.model.isNew()) return true
				//#21507 disable save on existing docking nodes on the SIPR
				if (isExistingDockingNipr(this.model)) return false
				//on the NIPR, new docking nodes are pre-filled with all the necessary info so enable the save right away
				//on the SIPR, untransformed docking nodes are also pre-filled for transforming, so also enable them
				let isReplicated = this.originalModel.replicated()
				let isDocking = this.model.get('type') === 'docking'
				return (isDocking && !isReplicated) || this.originalModel.untransformedDocking()
			}
		})
		this.formView.on('change', this._change.bind(this))

		this.on('resize', function () {
			this.objectSelector && this.objectSelector.resize()
		}.bind(this))
	},

	render: function({ instadone } = {}) {
		this.removeChildren()
		this.renderHeader()

		if (this.handleNoEditing()) {
			return this
		}

		this.$el.append(template(this.context()))

		this.disableSnapshotCalendars()

		formHelper.writeToDom(this.model, this.el)
		// #36318 render dropdowns *after* formHelper.writeToDom, so we don't
		// end up with a blank calendar selected
		this.renderDropdowns()

		this.renderWeight(this.model.get('percentWeightingIgnoringPerformance'))
		// hide fields for the root if appropriate
		this.$('.non-root').toggleClass('is-not-displayed', !('root' != this.model.get('type')))
		// note these read from the form, so must call initialize first
		this.changeType(this.model.get('type'))
		this._filterTypes()
		this.changeAggregationType()
		// if the model has specified useEquationForAggregations and
		// "Use Equation" is a valid option, select it
		if (this.model.get('useEquationForAggregations') &&
			!this.$('[name=useEquationForAggregations]').is(':visible') &&
			this._hasUseEquationOption()) {
			this.$('[name=aggregationType]').val(USE_EQUATION).change()
		}

		// #36026 update enabled/disabled condition of calendar select
		// (when first rendering, this must come after updating the selection of
		// "useEquationForAggregations")
		this.updateCalendarEnabled()

		if (this.model.isNew()) {
			this.$('.move, .copy, .delete').hide()
			this.$('.save').text(i18n.get('common.create'))
			this.$('.edit-weight').hide()
			this.$('.cancel').attr('disabled', false)
			this.$('.mass-edit-info').addClass('is-not-displayed')
		}

		this.editButtons.delegateEvents().render().$el.addClass('edit-buttons-bottom')
		this.$('.edit-buttons-container').append(this.editButtons.el)

		new TextArea({el: this.$('textarea[name=description]')}).render()

		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: val => {
				// https://github.com/SpiderStrategies/Scoreboard/issues/31370
				if (this.labelField.$('input').prop('disabled')) {
					return
				}

				return requiredValidator(val)
			}
		}).render()

		this.renderOwnersAndUpdaters()
		this.thresholdOverrideEarliestDate = new DateInput({
			el: this.$('[name=thresholdOverrideEarliestDate]'),
			required: false
		}).render()

		this.toggle = new OnOffToggle({
			name : 'thresholdOverride',
			checked : false
		})
		this.toggle.on('change', this.toggleThresholdOverrideDate.bind(this))
		this.$('.toggle-container').append(this.toggle.el)
		this.toggle.render()

		//#21506 disable user input for existing docking nodes on the NIPR
		this.$('input[type=text], select').prop('disabled', isExistingDockingNipr(this.model))

		// Most selects have been converted to rich selects by this point.
		// Make sure remaining native selects are converted to rich selects
		selects(this.$('select[name="dataType"], select[name="higherBetter"], select[name="yesGood"]'))

		this.secure()

		this.handleTemplateCopies()

		this.assignmentAlerts = new AssignmentAlerts({
			assignmentView: this.$('.display-pane-body .scroll-container'),
			parent: this.$('.edit-buttons-container'),
			label: i18n.get('common.notifyAssignedUsersGroups.assignment')
		}).render()

		// Show updaters controls on the principal panel here
		this.$('.updaters .principal-panel').addClass('principal-panel-updaters')

		this.formView.start({
			isNew: this.model.isNew(),
			primaryButtonEl: this.$('.save'),
			instadone
		})

		// If user closed the mass-edit banner, don't show it again during the current session.
		if (JSON.parse(sessionStorage.getItem('hideMassEditBanner')) === user.model.id) {
			this.$('.mass-edit-info').addClass('is-not-displayed')
		}

		// #56290
		// Linked scorecard items should highlight their name if the source
		// item's name is not being used
		// #61491
		// or if the item is being created for the first time
		if (!this._isNameDescriptionUseFromSource() || this.model.isNew()) {
			this.$('[name=label]').select()
		}

		return this
	},

	renderHeader: function() {
		// issue #9939 for some reason the model between the header and this
		// view were getting out of sync after re-rendering the form, so just
		// reconstruct the header so it's always in sync
		_.result(this.header, 'remove')
		let id = this.previousId || this.model.id || this.model.get('parentId')
		this.header = new Header({
			model: this.model,
			subsection: 'edit',
			// TODO: Remove when V5 is no longer supported
			// Only remove the isV6() check.
			tabs: this.model.isNew() && isV6() ? '' : tabs({ id }),
			sendToOptions: SendToOptions.scorecardStructureImport()
				.concat(SendToOptions.scorecardValueImport()),
			importOptions: ImportOptions.forScorecardItem(this.model)
		})
		this.$el.empty().append(this.header.el)
		this.header.render()
		this.header.toggleRedDescendants(this.model.get('descendantLowestScore'))
	},

	renderDropdowns: function() {
		// issue 5831 make sure a calendar is always selected
		var calendarId = this.model.get('calendarId') || calendars.calendars[0].id
		dropdown.idLabels(this.$('select.calendar').empty(), calendars.calendars, calendarId)
		// render scoring type
		var scoringTypeId = this.model.get('scoringTypeId')
		dropdown.scoringType(this.$('select.scoring-type'), scoringTypeId)
		// render precision
		dropdown.precision(this.$('[name=precision]'), this.model.get('precision'))
		// render currencies
		if (_.size(currency.all()) > 1) {
			dropdown.currency(this.$('.currency-code'), this.model.get('currencyCode'))
		} else {
			this.$('.scorecard-currency-code').remove()
		}
		// render units
		dropdown.unit(this.$('select.unit'), this.model.get('unit'))
	},

	renderOwnersAndUpdaters: function() {
		_.invokeMap([this.ownersPanel, this.updatersPanel], 'remove')
		let url = `api/organizations/${this.model.get('organizationId')}/potential-assignees`
		this.updatersPanel = new ScorecardsUpdatersPanel({
			headingKey: 'common.updaters',
			placeholderKey: 'admin.ownersUpdaters.addUpdater',
			url,
			currentPrincipals: this.model.get('updaters')
		})
		// #32726 gives interactive users the ability to become owners of
		// scorecard items
		// #39307 Disallow view only users from being owners
		const params = $.param({
			includeViewOnly: false,
			includeActiveViewers: true
		})
		url = `${url}?${params}`
		this.ownersPanel = new ScorecardsOwnersPanel({
			headingKey: 'common.owners',
			placeholderKey: 'admin.ownersUpdaters.addOwner',
			url,
			currentPrincipals: this.model.get('owners')
		})
		this.ownersPanel.on('change', this._principalChange.bind(this))
		this.updatersPanel.on('change', this._principalChange.bind(this))
		this.$('.owners').append(this.ownersPanel.el)
		this.$('.updaters').append(this.updatersPanel.el)
		_.invokeMap([this.ownersPanel, this.updatersPanel], 'render')
	},

	renderAggregationType: function() {
		let yesNo = _.get(this.getScoringType(), 'standardScoringType') ==
			constants.YES_NO
		var aggregationTypes = yesNo ? yesNoAggregationTypes : numericAggregationTypes
		if (_.get(this.getScoringType(), 'isCustomText')) {
			if (_.get(this.getScoringType(), 'kpiValueType') === constants.UNSCORED_TEXT) {
				aggregationTypes = unscoredCustomTextAggregationTypes
			} else {
				aggregationTypes = customTextAggregationTypes
			}
		}
		var aggTypeSelect = this.$('[name=aggregationType]')
		dropdown.idLabels(aggTypeSelect.empty(), aggregationTypes, this.model.get('aggregationType'))
		// if no aggregation type selected, select the first as the default
		if (!aggTypeSelect.val()) {
			aggTypeSelect.prop('selectedIndex', 0)
		}
		// #14281 some browsers (Safari, Edge, IE11) will already have the first option
		// as their val() after switching between yes/no and other scoring types
		// but still need the change event so it appears as selected on the form
		aggTypeSelect.change()
		this.changeAggregationType()
	},

	getScoringType: function() {
		var scoringTypeId = this.$('[name=scoringTypeId]').val()
		return config.scoringType(scoringTypeId)
	},

	context: function () {
		let templateLink = '<a class="template-link text-link">' + i18n.get('template.templateNode') + '</a>'
		return _.extend({
			config,
			metricSettingsIntro: i18n.get('scorecard.builder.metricSettings.introduction',
				i18n.get(enums.scorecardItemType[this.model.get('type')]), templateLink),
			infoForMassEdit: i18n.get('scorecards.infoForMassEdit', adminLink.adminMassEditLink())
		}, this.model.toJSON())
	},

	// handle situations where editing isn't allowed based the scorecard item
	// is part of a template, or if it's a replicated object (that isn't a untransformed docking node)
	handleNoEditing: function() {
		let noMsgKey = null
		if (this.model.get('templateId')) {
			var noEditing = false
			// issue #11882 with the addition of editing start/end dates for template copies,
			// there will be something to edit unless this is a linked node using source owners,
			// and the user does not have the ability to modify the structure
			if (this.model.get('type') === 'linked' && this.model.get('useSourceOwners')) {
				noEditing = !permissions.structure(this.model.get('organizationId'))
			}
			// #21717 prevent editing of docking template copies
			noEditing = noEditing || this.model.get('type') === 'docking'
			if (noEditing) {
				noMsgKey ='scorecard.builder.metricSettings.cannotBeCustomized'
			}
		}

		if (!permissions.isEditableIfReplicated(this.model) && !this.model.get('originallyDocked')) {
			noMsgKey = 'common.replication.editingReplicated.sipr'
		}

		let pendingDelete = !!this.model.get('pendingDeletion')
		if (noMsgKey || pendingDelete) {
			// Render the template
			this.$el.append(template({
				noEditing: true,
				pendingDelete
			}))
			if (noMsgKey) {
				// Insert the empty state display-pane-body into this
				// display-layout's scroll container
				this.$el.find('.scroll-container').append(cannotEdit({ messageKey: noMsgKey }))
			}
			return true
		}
		return false
	},

	hasEditOwnerPermission: function () {
		return permissions.ownersUpdaters(this.model.get('organizationId'))
	},

	// handle editing metrics that are part of template copies
	handleTemplateCopies: function() {
		if (!this.model.get('templateId')) {
			return
		}

		// #15318 yes-no and non-yes-no metrics are treated the same
		var isMetric = this.model.get('type') === 'metric'

		// copy metrics can have their series information changed, though yes-no metrics don't have anything to edit
		var showOwners = this.hasEditOwnerPermission()
		var showUpdaters = this.hasEditOwnerPermission() && isMetric

		if (this.model.get('type') === 'linked' && this.model.get('useSourceOwners')) {
			// if it's a linked node and using the source owners, we don't show those inputs
			showOwners = showUpdaters = false
		}

		// show the banner explaining what's going on
		this.$('.edit-template-copy').removeClass('is-not-displayed')

		// #15318 Allow template override for non-yes-no and yes-no metric
		this.$('.metric-settings').toggleClass('is-not-displayed', !isMetric)

		// issue #11882 show a panel containing advanced options button
		// to set start/end dates for non-metrics and yes no metrics
		this.$('.non-metric-settings').toggleClass('is-not-displayed', isMetric)

		// #15708 handle rollup specific settings for template copies
		var hasRollup = _.some(this.$('select.update-type'), function (el) {
			return $(el).val() === 'rollup'
		})

		if (hasRollup) {
			// cannot change the Aggregation Type if any of the series are Rollup
			this.$('[name=aggregationType]').prop('disabled', true)
			selects(this.$('[name=aggregationType]'))

		}
		// #18920 remove rollup option for series that are not currently rollup
		_.each(this.$('select.update-type'), function (el) {
			if ($(el).val() === 'rollup') {
				// cannot change the update type of a series if it is currently Rollup
				$(el).prop('disabled', true)
				selects($(el))
			} else {
				// cannot change a Manual or Calculated series to Rollup
				$(el).find('option[value=rollup]').remove()
			}
		})

		// hide stuff that's always hidden
		this.$('.scorecard-info, .choose-source-item, .use-from-source-item, .edit-buttons.delete, .move').addClass('is-not-displayed')
		this.$('.metric-details label:not(.scorecard-aggregation-type, .scorecard-calculated-aggregation-type)').addClass('is-not-displayed')

		// #35874 display calendar select if calendarId is null
		// (this can happen after using "override template" on a templated
		// dataset kpi if the update type is changed from dataset to manual)
		this.toggleTemplateCalendarDisplay()

		// owner/updater inputs are sometimes shown
		this.$('.owners').toggleClass('is-not-displayed', !showOwners)
		this.$('.updaters').toggleClass('is-not-displayed', !showUpdaters)

		// Fix move/copy joined button since it's just a single button now
		this.$('.copy').removeClass('button-right-joined')
		this.toggleUseTemplate()

		selects(this.$('select[name="useTemplate"]'))
	},

	toggleUseTemplate: function() {
		var useTemplate = 'true' === this.$('[name=useTemplate]').val()
		this.$('.metric-details, .series-info').toggleClass('is-not-displayed', useTemplate)
		this.toggleTemplateCalendarDisplay()
	},

	/**
	 * Toggles the display of the calendar select for templated copies.
	 * Normally the calendar does not display for copies when 'override template'
	 * is chosen, but for template copy dataset KPIs, this prevents null calendars
	 * if the dataset update type has been changed to 'Manual'
	 */
	toggleTemplateCalendarDisplay() {
		let useTemplate = 'true' === this.$('[name=useTemplate]').val()
		if (useTemplate) {
			return
		}
		/* #36427 #36283 display the calendar for a template copy metric if:
			"override template" is selected AND
			the template does not require a calendar AND
			the current metric does require a calendar based on the series selections
		*/
		let templateRequiresCalendar = _.get(this.originalModel.attributes, 'templateRequiresCalendar', true)
		let showCalendar = this.metricRequiresCalendar() && !templateRequiresCalendar
		this.$('.scorecard-calendar').toggleClass('is-not-displayed', !showCalendar)
	},

	toggleThresholdOverride: function() {
		this.$('.threshold-override').removeClass('is-not-displayed')
	},

	toggleThresholdOverrideDate: function(val) {
		this.$('.threshold-override-date').toggleClass('is-not-displayed', !val)
		this.model.set('thresholdOverride', val)
	},

	// filter the item type dropdown as appropriate
	_filterTypes: function() {
		var type = this.$('[name=type]').val()
		if (!type) {
			type = this.model.get('type')
			//type can be null in the case of the high side when editing an untransformed docking node because the docking
			//node option is not available on the high side so in this case, just set to the first option
			this.$('[name=type]')[0].selectedIndex = 0
		}

		// this is a new node
		if (this.model.isNew()) {
			// ... and the parent is a metric
			if (this.model.get('parentType') === 'metric') {
				// remove all the options other than metric and linked node
				this.$('[name=type] option').each(function() {
					if ($(this).val() !== 'metric' &&
						$(this).val() !== 'linked') {
						$(this).remove()
					}
				})
			}
		// this is an existing node
		} else {
			let isUntransformedDocking = this.model.untransformedDocking()
			this.$('[name=type] option').each(function() {
				// don't allow switching metrics to non-metrics and vice versa
				if (type === 'metric' && $(this).val() !== 'metric') {
					$(this).remove()
				}
				if (type !== 'metric' && $(this).val() === 'metric' && !isUntransformedDocking) {
					$(this).remove()
				}
				// don't allow switching linked nodes
				if (type === 'linked' && $(this).val() !== 'linked') {
					$(this).remove()
				}
				if (type !== 'linked' && $(this).val() === 'linked' && !isUntransformedDocking) {
					$(this).remove()
				}

				if (type === 'docking') {
					//for untransformed docking nodes on the SIPR side, allow changing the type into anything except
					//root or docking nodes
					if (isUntransformedDocking) {
						if ($(this).val() === 'root' || $(this).val() === 'docking') {
							$(this).remove()
						}
					} else if ($(this).val() !== 'docking') {
						$(this).remove()
					}
				}
				if (type !== 'docking' && $(this).val() === 'docking') {
					$(this).remove()
				}
			})
		}
		selects($('[name=type]'))

		return this
	},

	/**
	 * Removes unwanted default values from the model when creating new nodes.
	 * See https://basecamp.com/1979020/projects/5791995/messages/48148204#comment_331349203
	 * Also from #9011, we don't want to keep the sourceId
	 * From #15941 we don'tw ant to keep start/archive dates
	 */
	_unsetUnwantedDefaults: function() {
		if (this.model.isNew()) {
			var unwanted = ['id', 'label', 'description', 'percentWeighting',
				'series', 'sourceId', 'owners', 'updaters', 'tags', 'notes',
				'start', 'archive', 'percentWeightingIgnoringPerformance']
			_.each(unwanted, function(attribute) {
				this.model.unset(attribute, { silent: true })
			}.bind(this))
		}
	},

	_principalChange: function() {
		this.formView.change()
		this.assignmentAlerts.activate()
	},

	_change: function() {
		let type = this.$('select.item-type').val()
		let selected = this.objectSelector && this.objectSelector.selected()
		var noValidLinkSource =
			type === 'linked' &&
			(!selected || selected.type === 'docking')
		if (noValidLinkSource) {
			this.$('.button-primary').addClass('is-disabled')
		}

		if (type !== 'linked') {
			this.model.set({
				sourceId: null,
				sourceType: null
			})
		}

		// let this.updateLabelFromSource run first so the tree has the correct
		// label
		process.nextTick(function() {
			this.trigger('change', formHelper.readFromDom(this.el))
		}.bind(this))
	},

	// changes the display of the percent weighting on the form to the given value
	renderWeight: function(value) {
		this.$('.weight').text(formatValue({
			value: value,
			dataType: 'percent'
		}))
	},

	// show appropriate controls for the selected node type.  optionally also
	// change the node type to the passed in value
	changeType: function(type) {
		// set heading for new scorecard items, e.g. "Create Metric"
		if (this.model.isNew()) {
			var typeLabel = this.$('[name=type] option:selected').text()
			this.$('h1').text(i18n.get('common.create2', typeLabel))
		}

		// toggle the visibility of fields as appropriate for the item type
		type = _.isString(type) ? type : this.$('[name=type]').val()
		this.$('select.item-type').val(type)
		this.$('.metric:not(.linked)').toggle('metric' === type)
		this.$('.linked:not(.metric)').toggle('linked' === type)
		// if we change from a perspective to a metric, we need to make sure
		// fields like aggregation type are drawn correctly
		if (type === 'metric') {
			this.changeScoringType()
		}
		if (type === 'linked') {
			this.renderSourceItemObjectSelector()
			this.updateLabelFromSource()
		} else {
			this._toggleNameDescriptionDisabled(false)
		}

		//handle docking nodes & dereferenced
		let dereferenced = this.model.get('dereferenced')
		let isLowSideDocking = type === 'docking' && !this.model.get('originallyDocked')

		//for docking nodes on the low side, we want to hide all the stuff that don't pertain to docking nodes
		//for docking nodes on the high side, these nodes are intended to be transformed into regular nodes, so we don't
		//need to do any special hiding
		this.$('.owners, .advanced, .scorecard-description')
			.toggleClass('is-not-displayed', isLowSideDocking || dereferenced)

		// handle linked nodes
		// #32577 Make sure this is done after lowsidedocking/dereferenced toggle so owners
		// is not displayed when it shouldn't be
		// #47304 we don't need to toggle the owners if we've already decided
		// it should be hidden
		if (!isLowSideDocking) this._toggleOwnersForLinked()
		this.$('.edit-weight').toggleClass('is-not-displayed', isLowSideDocking || dereferenced || 'root' === this.model.get('type'))
		this._wasDocking = this._wasDocking || false
		if (isLowSideDocking) {
			this._wasDocking = true
			this.model.set('label', i18n.get('scorecards.node.docking'))
			this.$('.scorecard-name-text').val(i18n.get('scorecards.node.docking'))
			_.result(this.labelField, 'clearError')
			this.$('[name=label]').prop('disabled', true)
		} else if (this._wasDocking) {
			this._wasDocking = false
			this.model.unset('label')
			this.$('.scorecard-name-text').val('')
			this.$('[name=label]').prop('disabled', false)
		}
		//disable label changing for dereferenced nodes and docking nodes on the low
		this.$('.scorecard-name-text').prop('readonly', isLowSideDocking || dereferenced)
		this.$('[name=type]').prop('disabled', dereferenced)
	},

	renderSourceItemObjectSelector: function () {
		if (!this.objectSelector) {
			this.objectSelector = new ObjectSelector({
				section: 'scorecards',
				id: this.model.get('sourceId'),
				// #22340 respect start/archive dates
				periodId: globals.periodId,
				objectParams: {
					description: true
				}
			})
			this.objectSelector.on('select', function (e) {
				this.formView.change(e)
				this.updateLabelFromSource()
			}.bind(this))
			this.objectSelector.on('end', this.updateLabelFromSource.bind(this))
		}
		this.$('.object-selector').replaceWith(this.objectSelector.el)
		this.objectSelector.render()
	},

	changeUseSourceName: function(e) {
		this.updateLabelFromSource()
		this._toggleNameDescriptionDisabled(e.target.checked)
		this.formView.change(e)
	},

	_isNameDescriptionUseFromSource: function () {
		return this.$('[name=useSourceName]')[0].checked
	},

	updateLabelFromSource: function(e) {
		var selected = this.objectSelector.selected()
		var useSourceChecked = this._isNameDescriptionUseFromSource()
		if (this.$('select.item-type').val() === 'linked' && useSourceChecked &&
				selected) {
			this.$('[name=label]').val(selected.label)
			this.$('[name=description]').val(selected.description)
		}
		this._toggleNameDescriptionDisabled(useSourceChecked)
		_.result(this.labelField, 'clearError')
	},

	_toggleNameDescriptionDisabled: function(disabled) {
		this.$('[name=label], [name=description]').prop('disabled', disabled)
	},

	// toggles the owners box appropriately for linked nodes
	_toggleOwnersForLinked: function() {
		// show owners if
		var showOwners =
			// it's not a linked node
			this.$('[name=type]').val() !== 'linked' ||
			// ... or it's a linked node and useSourceOwners = false
			(this.$('[name=type]').val() === 'linked' &&
				!this.$('[name=useSourceOwners]')[0].checked)
		this.$('.owners').toggleClass('is-not-displayed', !showOwners)
	},

	// show appropriate controls for the selected scoring type
	changeScoringType: function() {
		if ('metric' != this.$('select.item-type').val()) {
			return
		}

		// toggle appropriate fields based on the scoring type
		let scoringType = this.getScoringType()
		let yesNo = _.get(scoringType, 'standardScoringType') ==
			constants.YES_NO
		let customText = _.get(scoringType, 'isCustomText', false)
		this.$('.series-info, .scorecard-data-type').toggleClass('is-not-displayed',
			customText)
		this.$('.scorecard-yes-no').toggle(yesNo)
		this.$('.numeric, .currency').toggle(!(yesNo || customText))
		this.$('.goal-only').toggleClass('is-not-displayed',
			_.get(scoringType, 'standardScoringType') != constants.GOAL_ONLY)
		// make sure appropriate fields are displayed based on the data type
		this.changeDataType()
		this.renderAggregationType()
		// render actual and threshold dropdowns
		var html = _.reduce(seriesNames(scoringType.id), function(html, series, index) {
			return html + scorecardsEditSeries(_.extend({replicated: _.result(this.model,'replicated')},{ series }))
		}.bind(this), '')
		let seriesInfoRow = this.$('.series-info .series-info-row')
		seriesInfoRow.html(html)
		_.each(this.$('.set-equation'), el => {
			new EditableButton({
				el,
				extraClasses: 'set-equation',
				message: 'scorecards.node.metric.equation.set'
			}).render()
		})

		// TODO: If there can be > 3 of these we'll have to account for more
		// rows than one

		// populate all the update type dropdowns at once, BAM!
		dropdown.idLabels(this.$('select.update-type').empty(), updateTypes)

		// set correct defaults for the new dropdowns
		this.$('select.update-type').each((index, el) => {
			var series = this.model.get('series')
			var updateType = series && series[index] && series[index].updateType
			$(el).val(updateType || 'manual')
			this.changeSingleUpdateType(el)
		})

		// remove the dataset update type if the series wasn't already a dataset
		// series (you can only create dataset series from the datasets overview)
		let seriesByKey = _.keyBy(this.model.get('series'), 'key')
		_.each(seriesInfoRow.find('.fieldset-wrapper'), (el, index) => {
			let seriesKey = $(el).data('series') + '.short'
			if (_.get(seriesByKey[seriesKey], 'updateType') != 'dataset') {
				$(el).find('.update-type option[value="dataset"]').remove()
			}
		})

		this.updateAggregationTypes()
		selects(this.$('.series-info .row select'))

		this.handleDatasetSeries()
		this.$('select.update-type').change()
	},

	// callback when the user changes an update type
	changeUpdateType: function(e) {
		var el = $(e.target)
		this.changeSingleUpdateType(el)
		this.updateAggregationTypes()
		this.updateRollupAggregationType()
		this.handleDatasetSeries()
	},

	/**
	 * Toggles fields that should be hidden depending on the dataset series
	 * selections
	 */
	handleDatasetSeries: function() {
		// we usually show the calendar and aggregation type, but it should be
		// hidden if all the series are dataset series which aren't based on a
		// SNAPSHOT of the data (#19791)
		// #29359 show calendar period select even when created using a calendar
		// from a dataset's date field
		// #36026 - we will always be displaying the calendar, so changes to the
		// calendar display have been removed from this method.  Whether the
		// calendar is disabled is handled by metricRequiresCalendar
		let showAggregationType = this.metricRequiresAggregationType()
		this.$('.scorecard-aggregation-type')
			.toggleClass('is-not-displayed', !showAggregationType)

		// #18842 the rules for template copies take precedence over the rules
		// for all series being datasets or not
		this.handleTemplateCopies()
	},

	/**
	 * Returns true if *any* of the series require the aggregation type (#36637)
	 */
	metricRequiresAggregationType: function() {
		// get the current state of the series so this will work with both new
		// and existing kpis
		let currentSeries = this.buildAllCurrentSeries()
		return _.some(currentSeries, series =>
			this.seriesRequiresAggregationType(series))
	},

	/**
	 * Returns true if a particular series requires an aggregation type
	 */
	seriesRequiresAggregationType: function(series) {
		let updateType = series.updateType
		if (updateType === 'dataset') {
			let datasetSeries = JSON.parse(series.equation)
			// non-snapshot dataset series do not require an aggregation type
			return datasetSeries.calendarFieldId == SNAPSHOT
		} else {
			// all other update types require an aggregation type
			return true
		}
	},

	/**
	 * #36026 Updates the enabled/disabled state of the calendar dropdown.
	 */
	updateCalendarEnabled: function() {
		let isTemplateCopy = !_.isNil(this.model.get('templateId'))
		if (isTemplateCopy) {
			this.toggleTemplateCalendarDisplay()
		}

		let requiresCalendar = this.metricRequiresCalendar()

		this.$('[name=calendarId]').prop('disabled', !requiresCalendar)
		selects(this.$('[name=calendarId]'))
	},

	/** displays a tooltip when calendar is disabled for calculated kpi (#36026) */
	showDisabledCalendarTooltip: function() {
		if (!this.metricRequiresCalendar()) {
			this.calendarNotRequiredTooltip = new Tooltip({
				closeOnChangedFocus: true,
				attachTo: this.$('.scorecard-calendar'),
				placement: 'above',
				arrow: 'center',
				content: i18n.get('scorecards.calendarNotRequiredTooltip')
			}).render()
		}
	},

	/**
	 * Returns true if *any* of the series require a calendar (#36026)
	 * https://github.com/SpiderStrategies/Scoreboard/issues/36026#issuecomment-802743487
	 */
	metricRequiresCalendar: function() {
		// get the current state of the series so this will work with both new
		// and existing kpis
		let currentSeries = this.buildAllCurrentSeries()
		let useEquation = false
		if (this.$('[name=useEquationForAggregations]').is(':visible')) {
			useEquation = this.$('[name=useEquationForAggregations]').val()
		} else {
			useEquation = this.$('[name=aggregationType]').val() === USE_EQUATION
		}
		let metricRequiresCalendar = _.some(currentSeries, series =>
			this.seriesRequiresCalendar(series, useEquation))
		return metricRequiresCalendar
	},

	/**
	 * Returns true if a particular series requires a calendar (#36026)
	 */
	seriesRequiresCalendar: function(series, useEquation) {
		let updateType = series.updateType
		if (updateType === 'calculated') {
			let equation = _.get(series, 'equation')
			// if the equation isn't set yet, assume the calendar is required
			// if we are not using "use equation" aggregation type, a
			// calendar is required
			if (_.isNil(equation) || !useEquation) {
				return true
			}
			// see if the equation requires a calendar (and useEquation = true)
			let matches = metricEquationParser.parse(equation)
			let equationRequiresCalendar = _.some(matches, match => {
				return match.type === 'td' || _.has(match, 'periodDirection')
			})
			return equationRequiresCalendar
		} else if (updateType === 'dataset') {
			let datasetSeries = JSON.parse(series.equation)
			// non-snapshot dataset series do not require a calendar
			return datasetSeries.calendarFieldId == SNAPSHOT
		} else {
			// all other update types require a calendar
			return true
		}
	},

	/** returns true if all series are calculated */
	allCalculated: function() {
		return  _.every(this.$('select.update-type'), function (el) {
			return $(el).val() === 'calculated'
		})
	},

	// displays the default threshold input box or the set equation
	// button, as appropriate.  also shows the missing value treatment dropdown
	// for calculated series.  optionally change the update type as well.
	// this method should be called manually, not as an event handler
	changeSingleUpdateType: function(el, updateType) {
		// if the el passed in is an event instead, change it to an element
		el = $(el)
		updateType = updateType || el.val()
		el.val(updateType)
		var fieldset = el.closest('.fieldset-wrapper')
		var index = fieldset.index()
		// all the series
		var series = this.model.get('series')
		// just the current series (e.g. actual value)
		var currentSeries = series && series[index]

		// render the MVT dropdown BEFORE it is possibly hidden
		var mvt = currentSeries && series[index].missingValueTreatment
		mvt = mvt ?? config.defaultMissingValueTreatment
		dropdown.mvt(fieldset.find('select.missing-value-treatment').empty(), mvt)

		// #16496 always show default value for rollup series
		let showDefaultValue = index != 0 && (updateType === 'manual' || updateType === 'rollup')
		fieldset.find('.series-input-wrapper').toggle(showDefaultValue)
		fieldset.find('.missing-value-treatment').toggle('manual' !== updateType)
		fieldset.find('.set-equation').toggle('calculated' === updateType)
		fieldset.find('.dataset-series').toggle('dataset' === updateType)

		if ('calculated' === updateType) {
			this.setEquationLabel(fieldset, _.get(currentSeries, 'equation'))
		}
		if ('dataset' === updateType) {
			fieldset.find('.dataset-series .text').text(
				this.model.getDatasetSeriesLabel(currentSeries))
		}
		if ('rollup' === updateType) {
			this.renderDefaultValueInput(fieldset)
		}
		if ('manual' === updateType) {
			this.renderDefaultValueInput(fieldset)
		}
	},

	// render the default value input for a series if needed
	renderDefaultValueInput: function (fieldset) {
		var index = fieldset.index()
		if (index != 0) { // actual value doesn't have a default value
			// create marked-field if it's missing
			if (fieldset.find('.series-input-wrapper > span.marked-field').length == 0) {
				//fieldset.find('.text-label').append('<span class="series-input-wrapper"><input type="text" placeholder="' + i18n.get('scorecards.node.metric.threshold.defaultValue') + '" class="default-value small"/></span>')
				var series = this.model.get('series')
				var value = series && series[index] && series[index].value
				fieldset.find('.default-value').val(value)
				var markedField = new MarkedField({
					el: fieldset.find('.series-input-wrapper input'),
					evaluator: numericEvaluator,
					validator: numericValidator,
					dataType: this.$('[name=dataType]').val(),
					currencyCode: this.$('[name=currencyCode]').val(),
					unit: this.$('[name=unit]').val()
				}).render()
				markedField.mark()
				this._markedFields.push(markedField)
			}
			// make sure the input is shown
			// we've got to clear the display property here instead of calling
			// jquery's show(). show() can apply display:inline to an element
			// (maybe because its not in the dom?) #5719
			fieldset.find('input.default-value').data('view').$el.css('display', '')
		}
	},

	// display the equation on the set equation button if exists
	setEquationLabel : function(fieldset, equation) {
		fieldset.find('.set-equation').data('view').renderLabel(equation)
	},

	// update the aggregation type and calculated aggregation type dropdowns
	// as appropriate based on the rules from
	// http://development.spiderstrategies.com/trac/ticket/11633#comment:12
	updateAggregationTypes: function() {
		// yes-no doesn't have a calculated aggregation type
		let scoringType = config.scoringType(this.$('select.scoring-type').val())
		if (_.get(scoringType, 'standardScoringType') == constants.YES_NO) {
			this.$('.scorecard-calculated-aggregation-type').addClass('is-not-displayed')
			this._removeUseEquationOption()
			return
		}

		let updateTypes = _.map(this.$('select.update-type'), el => $(el).val())
		let someCalculated = _.includes(updateTypes, 'calculated')
		let allCalculatedOrDataset = _.every(updateTypes, type =>
			(type == 'calculated' || type == 'dataset'))

		// if there are no calculated series, show aggregation type with 4 options
		if (!someCalculated) {
			this.$('.scorecard-calculated-aggregation-type').addClass('is-not-displayed')
			this._removeUseEquationOption()
		// if all calculated/dataset, show aggregation type with extra "use equation" option
		// (if the aggregation type should not be displayed based on if dataset
		// series is non-snapshot, that will be handled by 'handleDatasetSeries')
		} else if (allCalculatedOrDataset) {
			this.$('.scorecard-calculated-aggregation-type').addClass('is-not-displayed')
			// make sure there's a "use equation" aggregation type shown
			if (!this._hasUseEquationOption()) {
				var option = new Option(i18n.get('scorecards.node.metric.aggregationType.useEquation'), USE_EQUATION)
				this.$('[name=aggregationType]').append(option)
				// add an appropriate icon
				this.$('[name=aggregationType] option:last').attr('data-icon', 'calculated')
				this.$('[name=aggregationType]').closest('fieldset').find('div.select').remove()
				selects(this.$('[name=aggregationType]'))
			}
		// if a mix, show both aggregation type and calculated aggregation type dropdowns
		} else if (someCalculated) {
			this.$('.scorecard-calculated-aggregation-type').removeClass('is-not-displayed')
			this._removeUseEquationOption()
		}
		this.setAggregationTypeLabel()
	},

	updateRollupAggregationType: function() {
		//populate select with appropriate aggregation types
		var hasRollup = _.some(this.$('select.update-type'), function(el) {
			return $(el).val() === 'rollup'
		})
		// #16153 Note: hasRollup may also be false if the update type selects haven't been rendered yet
		// when this method is called from render() via changeType()
		// so we don't want to populate/set the rollup agg value just yet
		if (!hasRollup) {
			this.$('.scorecard-rollup-aggregation-type').toggleClass('is-not-displayed', !hasRollup)
			return
		}
		var rollupAggTypeSelect = this.$('[name=rollupAggregationType]')
		var prevRollupAggType = rollupAggTypeSelect.val() || this.model.get('rollupAggregationType')
		// populate the rollupAggregationSelect with the default (sum, average, geometric mean)
		dropdown.idLabels(rollupAggTypeSelect.empty(), numericRollupAggregationTypes, prevRollupAggType)
		// if any of the series has rollup update type, display rollup aggregation type
		let isCustomText = _.get(this.getScoringType(), 'isCustomText')
		this.$('.scorecard-rollup-aggregation-type').toggleClass('is-not-displayed', !hasRollup || isCustomText)

		var aggTypeSelect = this.$('[name=aggregationType]')
		let scoringType = config.scoringType(this.$('select.scoring-type').val())
		if (_.get(scoringType, 'standardScoringType') == constants.YES_NO) {
			if (aggTypeSelect.val() === 'last-value') {
				// populate the dropdown with percentage-yes, number-of-yeses
				dropdown.idLabels(rollupAggTypeSelect.empty(), yesNoRollupAggregationTypes, this.model.get('rollupAggregationType'))
			}
			if (aggTypeSelect.val() === 'percentage-yes') {
				// hide rollup aggregation type and set average as the default for percentage yes
				this.$('.scorecard-rollup-aggregation-type').toggleClass('is-not-displayed', true)
				rollupAggTypeSelect.val('average').change()
			}
			if (aggTypeSelect.val() === 'number-of-yeses') {
				// populate the dropdown with sum, average
				dropdown.idLabels(rollupAggTypeSelect.empty(), numberOfYesesAggregationTypes, this.model.get('rollupAggregationType'))
			}
		}
		// #15704 change rollup aggregation type to match aggregation type
		// (but not when form is initially being loaded)
		// #16153 formView won't be defined yet due to #16002 changes
		if (this.formView && this.formView.started) {
			if (aggTypeSelect.val() && _.some(numericRollupAggregationTypes, ['id', aggTypeSelect.val()])) {
				rollupAggTypeSelect.val(aggTypeSelect.val()).change()
			} else {
				rollupAggTypeSelect.prop('selectedIndex', 0).change()
			}
		}
		this.setAggregationTypeLabel()
	},

	// #12917 set the label for aggregationType
	// #18037 updated rules: - label for manual aggregation type will be "Aggregation Type",
	// except when "Calculated Aggregation Type" is present, then use "Manual Aggregation Type".
	// The label will still be "Aggregation Type" when only one aggregation type is present
	// (when all series are calculated, or for a calculated yes/no scoring type)
	setAggregationTypeLabel: function() {
		var aggTypeLabel = i18n.get('scorecards.node.metric.aggregationType.aggregationType')
		var selector = '.scorecard-aggregation-type,.scorecard-calculated-aggregation-type,.scorecard-rollup-aggregation-type'
		var numVisibleAggTypes = this.$(selector).filter(':visible').length
		var someCalculated = _.some(this.$('select.update-type'), function (el) {
			return $(el).val() === 'calculated'
		})
		if (someCalculated && numVisibleAggTypes > 1) {
			aggTypeLabel = i18n.get('scorecards.node.metric.aggregationType.aggregationType.manual')
		}
		this.$('.scorecard-aggregation-type').find('.label-text').text(aggTypeLabel)
	},

	_removeUseEquationOption: function() {
		if (this.$('[name=aggregationType]').val() === USE_EQUATION) {
			this.$('[name=aggregationType]').prop('selectedIndex', 0).change()
		}
		this.$(`[name=aggregationType] option[value='${USE_EQUATION}']`).remove()
	},

	changeAggregationType: function() {
		// copy text and icon from aggregation type dropdown to calculated
		// aggregation type dropdown
		var selected = this.$('[name=aggregationType] option:selected')
		this.$('[name=useEquationForAggregations] option').eq(0)
			.text(selected.text() + ' ' + i18n.get('scorecards.node.metric.aggregationType.recommended'))
			.attr('data-icon', selected.data('icon'))
		selects(this.$('[name=useEquationForAggregations]'))

		if (this.$('[name=aggregationType]').val() === USE_EQUATION) {
			this.$('[name=useEquationForAggregations]').val('true')
		}

		this.updateRollupAggregationType()
		// #36026 update the enabled/disabled state of the calendar
		this.updateCalendarEnabled()
	},

	changeDataType: function() {
		_.each([NUMBER, CURRENCY, PERCENT], function(dataType) {
			this.$('.' + dataType).toggleClass('is-not-displayed', this.$('[name=dataType]').val() !== dataType)
		}.bind(this))
		if (_.isEmpty(config.units)) {
			this.$('.scorecard-unit-number').addClass('is-not-displayed')
		}
		// issue 6766: make sure a data type is selected
		if (_.isEmpty(this.$('[name=dataType]').val())) {
			this.$('[name=dataType]').prop('selectedIndex', 0).change()
		}
		// issue 7591: Percentage Metrics Default to Average Aggregation
		if (this.$('[name=dataType]').val() === 'percent') {
			this.$('[name=aggregationType]').val('average').change()
			this.$('[name=rollupAggregationType]').val('average').change()
		}
		this._remark()
	},

	_remark: function() {
		_.invokeMap(this._markedFields, 'mark', {
			dataType: this.$('[name=dataType]').val(),
			currencyCode: this.$('[name=currencyCode]').val(),
			unit: this.$('[name=unit]').val()
		})
	},

	// displays the edit weight dialog
	weight: function() {
		//don't allow editing of weights for replicated objects
		if (!_.isNil(this.model.get('syncId')) && !this.model.transformedDocking()) {
			return
		}

		let period = calendars.periodsById[globals.periodId]
		this.model.loadWeights((weights) => {
			var form = new WeightForm({ model: this.model, weights: weights })
			appDisplay.dialog(form)
			form.once('save', (weights) => {
				// note the weights are saved right away, so there's no need to
				// trigger this.formView.change

				// calculate percent weighting
				var percentWeighting = 0
				var totalWeight = 0
				_.each(weights, (weightNode) => {
					let weight = weightInDateRange(weightNode.periods, period)
					totalWeight += weight
					if (weightNode.id == this.model.id) {
						percentWeighting = weight
					}
				})
				percentWeighting /= totalWeight

				this.renderWeight(percentWeighting)
			})
		})
	},

	goToOrigin: function() {
		conductor.edit('scorecards', this.model.get('sourceId'))
	},

	// shows the advanced dialog
	advanced: function() {
		var options = formHelper.readFromDom(this.el)
		options.model = this.model
		appDisplay.dialog($.get('api/tags'), globalTags => {
			options.globalTags = globalTags
			var form = new ScorecardsAdvancedForm(options)
			this.listenTo(form, 'done', this.formView.change.bind(this.formView))
			return form
		})
	},

	// shows the edit equation dialog
	equation: function(e) {
		// get the series name
		var fieldset = $(e.target).closest('.fieldset-wrapper')
		var series = fieldset.data('series')
		// init series in case it was missing
		this.model.set('series', this.model.get('series') || [])

		// create the form
		// can't rely entirely on this.buildScorecardNode() because that relies
		// on formHelper.readFromDom, which ignores hidden fields.  That's a
		// problem because when editing template-copies key fields like
		// calendarId will be hidden
		var attributes = _.extend({}, this.model.attributes, formHelper.readFromDom(this.el), {
			id: this.model.id,
			type: 'scorecard-item',
			organizationId: this.model.get('organizationId'),
			label: this.$('[name=label]').val(),
			calendarId: this.$('[name=calendarId]').val(),
			scoringTypeId: this.$('[name=scoringTypeId]').val()
		})
		this.buildScorecardNode(attributes)
		var model = new ScorecardNode(attributes)
		// #36327 if this was a KPI that doesn't need a calendar, send along
		// the calendar selected in the disabled calendar dropdown
		// (buildScorecardNode may have set the calendarId to null for certain
		// types, so we need to get it again)
		if (_.isNil(model.get('calendarId'))) {
			// get the value from the select
			let calendarId = this.$('[name=calendarId]').val()
			model.set('calendarId', calendarId)
		}
		this.equationForm = new EquationForm({ model: model, series: series })
		appDisplay.dialog(this.equationForm)
		this.equationForm.once('done', function(equation) {
			let allSeries = this.model.get('series')
			if (!allSeries[fieldset.index()]) {
				allSeries[fieldset.index()] = {}
			}
			// this is needed or else if you change scoring types the system
			// forgets the series was supposed to be calculated
			allSeries[fieldset.index()].updateType = 'calculated'
			allSeries[fieldset.index()].equation = equation
			this.setEquationLabel(fieldset, equation)
			// #36026 update the calendar's enabled/disabled status as needed
			// after editing equation
			this.updateCalendarEnabled()
			this.formView.change()
		}.bind(this))
	},

	editDatasetSeries: function(e) {
		// the text-link should instead drill down to the dataset or dataset view
		if ($(e.target).hasClass('text-link')) {
			return
		}

		let series = this.getSeries(e)
		let seriesIndex = this.getSeriesIndex(e)
		let datasetSeriesXhr = this.getDatasetSeriesXhr(e)
		// #58339
		// Store the fieldset that the dataset series dialog was opened from
		// for uses such as changing the dataset series label
		let fieldset = $(e.target).closest('.fieldset-wrapper')

		if (!_.isNil(datasetSeriesXhr)) {
			appDisplay.dialog(datasetSeriesXhr, response => {
				// #26729 don't use the series from the request. Use the one in
				// the model instead.
				let { datasets, treeItems, organization } = response
				let datasetsById = _.keyBy(datasets, 'id')
				let datasetSeries = JSON.parse(series.equation)
				let dataset = new Dataset(datasetsById[datasetSeries.id])
				let datasetSeriesEditor = new DatasetSeriesEditor({
					model: dataset,
					datasetSeries,
					organization,
					filters: datasetSeries.filters,
					// #27041 the filters for dataset series don't have to do with
					// permissions
					showPermissionFilters: false,
					noneMessage: i18n.get('common.thereAreNo', 'report.updateMetricsReport.filters'),
					treeItemsById: _.keyBy(treeItems, 'id')
				})
				datasetSeriesEditor.on('done', ({ datasetSeries, equationLabel }) => {
					fieldset.find('.dataset-series .text').text(
						this.model.getDatasetSeriesLabelForEquation(datasetSeries))
					// needed so we can reuse this.filters, in case this dialog is
					// visited multiple times
					datasetSeries.filters = _.cloneDeep(datasetSeries.filters)
					series.equation = JSON.stringify(datasetSeries)
					series.equationLabel = equationLabel
					// datasetFieldId is stored in the DB for referential
					// since the rest of the data in datasetSeries is stored
					// as a String
					if (Dataset.isTotal(datasetSeries.columnFieldId)) {
						series.datasetFieldId = null
					} else {
						series.datasetFieldId = datasetSeries.columnFieldId
					}
					// #23589 show/hide fields (e.g. AggregationType) based on changes to
					// the dataset series
					this.handleDatasetSeries()
					this.formView.change()
				})
				return datasetSeriesEditor
			})
		}
	},

	viewDataset: function(e) {
		guard.conditionallyRun(() => {
			let datasetSeriesXhr = this.getDatasetSeriesXhr(e) || this.datasetSeriesXhr
			appDisplay.display(datasetSeriesXhr, ({ datasetSeries }) => {
				datasetSeriesDrilldown(datasetSeries[this.getSeries(e).key], this.filters)
			})
		})
	},

	/**
	 * Returns an XHR used to retrieve metadata about the dataset series in
	 * this scorecard node. Note the request contains information for ALL the
	 * series so it can be reused.
	 */
	getDatasetSeriesXhr: function(e) {
		let series = this.getSeries(e)
		let datasetSeries = JSON.parse(series.equation)
		let treeItemIds = treeIdsInFilters(datasetSeries.filters)
		if (!this.datasetSeriesXhr) {
			this.datasetSeriesXhr = $.get(`api/scorecards/${this.model.id}/dataset-series`, {
				fields: true,
				treeItemIds,
				linkedDatasets: true
			})
		} else if (this.datasetSeriesXhr.state() == 'rejected') {
			// This looks redundant, but it's here to keep showing the user the
			// error dialog if they repeatedly click on the link to the dataset
			setupErrors.errorHandler(this.datasetSeriesXhr)
			return
		}
		return this.datasetSeriesXhr
	},

	/**
	 * Returns the corresponding series based on a click on the .dataset-series
	 * button
	 */
	getSeries: function(e) {
		var fieldset = $(e.target).closest('.fieldset-wrapper')
		return this.model.get('series')[fieldset.index()]
	},

	/**
	 * Returns the corresponding index for the series based on a click on the
	 * .dataset-series button
	 */
	getSeriesIndex: function(e) {
		return $(e.target).closest('.fieldset-wrapper').index()
	},

	cancel: function() {
		delete this.datasetSeriesXhr
		if (this.model.isNew()) {
			conductor.edit()
		} else {
			// necessary because setting the equation modifies the model
			this.model = this.originalModel
			// we really need to render again b/c this form is so complex.  we
			// can't just use the formHelper to set the values because we also
			// need to toggle which fields are visible
			this.render()
		}
	},

	validate: function(data) {
		if (data.type === 'linked') {
			if (!data.sourceId) {
				return i18n.get('admin.scorecards.linked.chooseSourceNode.required')
			} else if (data.sourceType === 'docking') {
				return i18n.get('admin.scorecards.linked.invalidSource')
			}
			let parent
			// data.parentId is only specified when creating new nodes
			if (data.parentId) {
				parent = appDisplay.navView().gardener.tree.get(data.parentId)
			} else {
				parent = appDisplay.navView().gardener.tree.parent(this.model.id)
			}
			if (parent.type === 'metric') {
				let source = this.objectSelector.objectGardener.tree.get(data.sourceId)
				if (_.get(source, 'type') != 'metric') {
					return i18n.get('admin.scorecards.linked.onlyLinkedMetricsUnderMetrics')
				}
			}
		}
	},

	/**
	 * Builds all the data for the scorecard node in a format suitable to send
	 * to the server
	 */
	buildScorecardNode: function(data) {
		// read owners and updaters
		if (this.$('.owners').is(':visible')) {
			data.owners = this.ownersPanel.getPrincipals()
		}
		if (this.$('.updaters').is(':visible')) {
			data.updaters = this.updatersPanel.getPrincipals()
		}
		// read sourceId
		let selected = this.objectSelector && this.objectSelector.selected()
		if (data.type === 'linked' && selected) {
			data.sourceId = selected.id
			data.sourceType = selected.type
		}
		let scoringType = config.scoringType(data.scoringTypeId)
		if (_.get(scoringType, 'standardScoringType') == YES_NO) {
			data.dataType = YES_NO
			// #11874 make sure the correct value is sent for rollupAggregationType
			if (data.aggregationType === 'percentage-yes') {
				data.rollupAggregationType = 'average'
			}
		}
		// construct series
		data.series = this.buildAllCurrentSeries()

		// after the series have been built, do checks for
		// useEquationForAggregations and rollupAggregationType
		if (data.type === 'metric') {
			var someCalculated = _.some(data.series, function (series) {
				return series.updateType === 'calculated'
			})
			if (someCalculated) {
				// #36271 set the value for  data.useEquationForAggregations
				// if the calculated aggregation type dropdown is visible,
				// use that value.  If it is not visible (ie when all series are
				// calculated), check to see if "Use Equation" is selected in the
				//  aggregation type dropdown.
				if (this.$('[name=useEquationForAggregations]').is(':visible')) {
					data.useEquationForAggregations = this.$('[name=useEquationForAggregations]').val()
				} else {
					data.useEquationForAggregations = this.$('[name=aggregationType]').val() === USE_EQUATION
				}
			} else {
				// #15188 useEquationForAggregations should be null if no calculated series
				data.useEquationForAggregations = null
			}

			// #15704 if user has modified to have no rollup series,
			// rollupAggregationType should be set to null
			var someRollup = _.some(data.series, function (series) {
				return series.updateType === 'rollup'
			})
			if (!someRollup) {
				data.rollupAggregationType = null
			}
		} else {
			// #51138 if this is not a metric, remove metric specific properties
			data.higherBetter = null
			data.yesGood = null
		}

		// #36276 clear calendarId if not needed based on equations/aggregation type
		if (!this.metricRequiresCalendar()) {
			data.calendarId = null
		}

		// Prevent Root Node from sending Chart on multiple saves
		delete data.chart
		// no need to send scores
		delete data.scores
	},

	/**
	 * Constructs the series based on the current state of the ui
	 * (extracted out for #36026)
 	 */
	buildAllCurrentSeries: function() {
		let series = this.model.get('series')
		let fieldsets = this.$('.series-info .fieldset-wrapper')
		let scoringTypeId = this.$('[name=scoringTypeId]').val()
		return _.map(seriesNames(scoringTypeId), (key, index) => {
			var fieldset = fieldsets.eq(index)
			var s = {
				key: key + '.short',
				updateType: fieldset.find('select.update-type').val()
			}
			let currentSeries = series && series[index] && series[index]
			if (s.updateType !== 'manual') {
				s.missingValueTreatment = fieldset.find('select.missing-value-treatment').val()
			}
			// #16496 don't wipe out equation for rollup series
			if (s.updateType === 'calculated' || s.updateType === 'dataset' || s.updateType === 'rollup') {
				s.equation = _.get(currentSeries, 'equation')
			}
			if (s.updateType === 'dataset') {
				s.datasetId = currentSeries.datasetId
				s.datasetFieldId = currentSeries.datasetFieldId
				s.equationLabel = currentSeries.equationLabel
			}
			if ((s.updateType === 'manual' || s.updateType === 'rollup') && index != 0) {
				s.value = fieldset.find('.default-value').data('view').val()
			}
			return s
		})
	},

	submit: function(e) {
		const data = _.extend({}, this.model.attributes, formHelper.readFromDom(this.el))
		delete data.datasets
		this.buildScorecardNode(data)

		// perform extra validation specific to this form
		var error = this.validate(data)
		if (error) {
			this.formView.error(error)
			return
		}

		// save the data

		// record the event here, before the new ID gets mixed into the model
		var event = this.model.isNew() ? 'add' : 'edit'
		this.model.periodId = globals.periodId
		return this.model.save(data, {
			patch: true,
			success: function(model) {
				this.previousId = model.id
				// note model.id is always populated at this point, so key on the event
				if (event === 'add') {
					this.model = this.model.clone()
					// this lets Backbone know the model is new
					this.model.unset('id')
					this._unsetUnwantedDefaults()
					this.model.set('label', i18n.get('scorecards.newItem'))
					this.editButtons.model = this.model

					// issue 5415 object selector missing after creating linked
					// node
					this.objectSelector && this.objectSelector.remove()
					delete this.objectSelector

				}

				this.trigger('save', model, this.model)
				triggerAddOrEdit(event, model, { relativeId: model.get('parentId') })
				// The tree was just edited, so trigger the nodeVisibility event
				// since node visibility could have been altered
				appDisplay.navView().gardener.trigger('change:nodeVisibility')
				// #22801 we count on this being false in
				// updateRollupAggregationType when deciding whether to toggle
				// the rollup aggregation type to equal the main aggregation
				// type
				this.formView.started = false

				//#21509 re-init with the new type
				let isTransformingDocking = this.originalModel.untransformedDocking() && this.model.transformedDocking()
				if (isTransformingDocking) {
					//if cancelling afterward, don't go back to the original, the new transformed model is the correct model
					this.originalModel = this.model
				}

				// don't fire these until AFTER events are fired above or else
				// on linked nodes new gardeners will be setup that will
				// immediately listen for add:domain-object and
				// edit:domain-object and blowup

				this.render({ instadone: true })
				this.delegateEvents()
				autofocus(this.el)
			}.bind(this),
			error: function(model, response, options) {
				this.formView.error(response)
			}.bind(this)
		})
	},

	// the remove is a little more complex than normal because we really need to
	// call .render again after clicking cancel b/c this form is so complex
	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.formView.remove()
		this.removeChildren()
	},

	removeChildren: function() {
		_.invokeMap([this.editButtons, this.header, this.equationForm,
			this.objectSelector, this.labelField, this.ownersPanel,
			this.updatersPanel, this.toggle, this.lockedTooltip,
			this.assignmentAlerts, this.disabledTooltip,
			this.calendarNotRequiredTooltip], 'remove')
		_.invokeMap(this._markedFields, 'remove')
	},

	secure: function () {
		var hasOwnerUpdater = permissions.ownersUpdaters(this.model.get('organizationId'))
		var hasStructure = permissions.structure(this.model.get('organizationId'))

		if (!hasStructure) {
			// if no structure permissions, hide all except owner updater panels
			this.$('.scorecard-info, .metric-details, .series-info, .metric-settings, ' +
				'.choose-source-item, .use-from-source-item, .move-copy, .delete-container').hide()
		}
		if (!hasOwnerUpdater) {
			// if no owner updater permission, remove owner updater panels
			this.ownersPanel.remove()
			this.updatersPanel.remove()
		}

		// issue #11872 for users with just owner/updater permission, if linked
		// items that are modified on the source, display an appropriate
		// message and a link to the source
		if (hasOwnerUpdater &&
				!hasStructure &&
				this.model.get('type') === 'linked' &&
				this.model.get('useSourceOwners')) {
			var type = enums.scorecardItemType[this.model.get('sourceType')]
			var key = this.model.get('sourceType') === 'metric' ?
				'scorecards.overview.ownerUpdater.editSourceWarning' :
				'scorecards.overview.owner.editSourceWarning'
			var msg = i18n.get(key, type)
			this.$('.owners-updaters-on-source').removeClass('is-not-displayed')
				.find('.edit-message').text(msg)
			this.$('.edit-buttons-container').addClass('is-not-displayed')
		}

		// #9199 show a tooltip if a node can't be edited
		// note nav may be null if we're inside a test
		var nav = appDisplay.navView()
		nav && nav._onceTreeLoaded(function() {
			if (!this.model.isNew() && locked(this.model.attributes, nav.gardener.tree)) {
				this.$('.scroll-container').html(
					'<div class="banner">' +
					_.escape(i18n.get('integrity.scorecards.outsideLockPeriod')) +
					'</div>'
				)
				this.$('.move, .delete, .save').addClass('is-disabled')
					.on('click', this.showLockedTooltip.bind(this))
			}
		}.bind(this))
	},

	// #9199 show a tooltip if a node can't be edited
	showLockedTooltip: function(e) {
		e.stopPropagation()
		_.invoke(this.lockedTooltip, 'remove')
		this.lockedTooltip = new Tooltip({
			attachTo: e.target,
			content: i18n.get('integrity.scorecards.outsideLockPeriod.tooltip'),
			placement: 'above',
			arrow: 'center'
		}).render()
	},

	_hasUseEquationOption: function() {
		return this.$(`[name=aggregationType] option[value='${USE_EQUATION}']`).length > 0
	},

	showReportWizard: function(e) {
		guard.conditionallyRun(() => {
			let wizard = new Wizard({model: new WizardInfo()})
			wizard.once('done', (report) => {
				Backbone.trigger('reports:generate', report)
				conductor.navigate('/reports/generate', {trigger: true})
			})
			appDisplay.dialog(wizard)
		})
	},

	generateScorecardAttributeReport: function(e) {
		guard.conditionallyRun(() => {
			//store the label of the root scorecard for #13646 when redirecting to use
			//the Scorecards Attribute report for mass editing
			let nav = appDisplay.navView()
			let rootLabel = ''
			if (nav) {
				rootLabel = nav.gardener.tree.get(nav.gardener.tree.root.id).label
			}
			let orgId = this.model.get('organizationId') || globals.orgId
			let rootId = this.model.get('rootId')
			let meta = {}
			meta[rootId] = {label: rootLabel}
			let report = new ScorecardAttributesReportModel({organizationId: orgId})
			report.setFilter({ancestorValues: [rootId], metadata: meta}, 'scorecardNodeIds', 0)
			Backbone.trigger('reports:generate', report)
			conductor.navigate('/reports/generate', {trigger: true})
		})

	},

	navigateToTemplate: function() {
		conductor.navigate('/scorecards/' + this.model.get('templateId'), {trigger: true})
	},

	// Hide the mass-edit-info banner for the duration of the session if the user manually closes it.
	hideMassEditBanner: function() {
		// Using the user id as the value in the off chance a user hides the banner,
		// signs out, but leaves the tab open and another user signs in
		sessionStorage.setItem('hideMassEditBanner', user.model.id)
		this.$('.mass-edit-info').addClass('is-not-displayed')
	},

	// Navigate to Admin > Mass Edit with starting filter based on the root of
	// the current scorecard item  (#43464)
	onClickMassEditLink: function() {
		let nav = appDisplay.navView()
		let label = ''
		if (nav) {
			label = nav.gardener.tree.get(nav.gardener.tree.root.id).label
		}
		let rootId = this.model.get('rootId')
		let metadata = {}
		metadata[rootId] = {label}
		let filter = {
			filterValue: {ancestorValues: [rootId], metadata },
			filterKey: 'scorecardNodeIds'
		}
		Backbone.trigger('mass-edit:filter', filter)
		conductor.navigate('/admin/mass-edit', { replace: true, force: true })
	},

	// #31433 disable calendar and add tooltip message on click if scorecard item is a snapshot
	// dataset KPI
	disableSnapshotCalendars: function() {
			var series = this.model.get('series')
			_.each(series, (individualSeries) => {
				if (individualSeries.equation && individualSeries.updateType === 'dataset') {
					let datasetSeries = JSON.parse(individualSeries.equation)
					if (datasetSeries.calendarFieldId == SNAPSHOT) {
						this.$('select.calendar')
							.addClass('disabled')
							.on('click', () => {
								this.showDisabledTooltip()
						})
					}
				}
			})
	},

	// #31433 display message on disabled calendar dropdown
	showDisabledTooltip: function() {
		this.disabledTooltip = new Tooltip({
			closeOnChangedFocus: true,
			attachTo: this.$('.scorecard-calendar'),
			placement: 'above',
			arrow: 'center',
			content: i18n.get('scorecards.snapshotKpiTooltip')
		}).render()
	}
})

export default ScorecardsEdit

ScorecardsEdit.__filename__ = 'scorecards/edit/scorecards-edit.js'
